import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ISubheaderParams } from './interface';

/**
 * Hide app header 
 */
@Injectable({
  providedIn: 'root'
})
export class LayoutManageService {

  private _subheaderParams: BehaviorSubject<ISubheaderParams> = new BehaviorSubject(null);
  
  private _isNavbarVisible$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor() { }

  public get isShowNavbar(): Observable<boolean> {
    return this._isNavbarVisible$.asObservable();
  }

  public get subheaderParams(): Observable<ISubheaderParams> {
    return this._subheaderParams.asObservable();
  }

  public switchToSubheader(params: ISubheaderParams): void {
    setTimeout(() => {
      this._subheaderParams.next(params);
    }, 1)
  }

  public setNavbarVisible(isVisible: boolean) {
    setTimeout(() => {
      this._isNavbarVisible$.next(isVisible)
    }, 1)
  }

  public resetState(): void {
    setTimeout(() => {
      this._isNavbarVisible$.next(true)
      this._subheaderParams.next(null);
    }, 1)
  }
}
